<template>
    <!-- 侧边搜索栏  与 相关新闻 -->
    <div class="sideSearch">
        <div class="top">
            <div>
                <el-input v-model="searchValue" placeholder="请输入您要查询的关键字"></el-input>
            </div>
            <div class="select">
                <el-select v-model="searchSelect" placeholder="选择分类" style="width: 66%;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-button type="primary" @click="toSearch">搜索</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'sideSearch',
    data() {
        return {
            searchValue: '',
            options: [
                {
                    value: '新闻中心',
                    label: '新闻中心'
                },
                {
                    value: '企业资讯',
                    label: '企业资讯'
                },
                {
                    value: '活动通知',
                    label: '活动通知'
                },
                {
                    value: '政策法规',
                    label: '政策法规'
                },
                {
                    value: '信用标准',
                    label: '信用标准'
                },
                {
                    value: '信用案例',
                    label: '信用案例'
                },
                {
                    value: '信用研究',
                    label: '信用研究'
                },
                {
                    value: '信用管理',
                    label: '信用管理'
                },
                {
                    value: '信用指数',
                    label: '信用指数'
                },
            ],
            searchSelect: '新闻中心',
        }
    },
    methods: {
        toDetail(item, title) {
            this.$router.push({
                name: 'newsDetail',
                query: {
                    documentTitle: item.title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/newsDetail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 搜索点击
        toSearch() {
            let _this = this
            if (_this.searchValue == '') {
                _this.$message.error('请输入关键字')
            } else {
                this.$router.push({
                    name: 'publicList',
                    query: {
                        documentTitle: _this.searchSelect,
                        searchName: _this.searchValue
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: "/publicList"
                // });
                // let title = _this.searchSelect
                // window.open(routeUrl.href+ '?documentTitle=' + title + '&searchName=' + _this.searchValue, '_blank');
            }
        }
    }
}
</script>

<style lang="less" scoped>
.sideSearch {
    .top {
        padding: 20px;
        background-color: #E8F1FF;
        /deep/ .el-input__inner {
            border-radius: 1px;
            font-size: 18px;
            border-color: #1A68E8;
        }
        /deep/ .el-button {
            border-radius: 1px;
            background-color: #1A68E8;
            width: 32%;
        }
        .select {
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>